import script from "./ChannelsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ChannelsWidget.vue?vue&type=script&setup=true&lang=js"
/* custom blocks */
import block0 from "./ChannelsWidget.vue?vue&type=custom&index=0&blockType=styles&lang=scss"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__